// extracted by mini-css-extract-plugin
export default {"form":"SettingsForm_form__zQNAm","action":"SettingsForm_action__UD0EL"};